import React from 'react';
import {Box, Divider, Grid, Typography} from "@material-ui/core";
import ConfigRenderInputs from "./ConfigRenderInputs";
import { setConfigType } from "../../utils/configUtils";

const ConfigFields = ({ inputs, setInputs, modalData, data, defaultCategory = false }) => {
    return (
        <>
            <Grid container spacing={3} style={{padding: '0'}}>
                <Grid item xs={12}>
                    <Typography variant="body1">
                        <Box display="flex" flexDirection="row" alignItems="center">
                            <strong>Config Fields</strong>
                        </Box>
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <ConfigRenderInputs
                        fieldType={"key"}
                        editProps={{
                            value: inputs.key || modalData.data['key'],
                            onChange: (val) => {
                                setInputs(inputs => ({
                                    ...inputs,
                                    key: val
                                }));
                            },
                            type: 'modal',
                        }}
                        disabled={!modalData.showAddRow}
                        data={data}
                    />
                </Grid>
                <Grid item xs={4}>
                    <ConfigRenderInputs
                        fieldType={"category"}
                        editProps={{
                            value: inputs.category || modalData.data['category'],
                            onChange: (val) => {
                                setInputs(inputs => ({
                                    ...inputs,
                                    category: val,
                                    type: setConfigType(val)
                                }));
                            },
                            type: 'modal',
                        }}
                        defaultCategory={defaultCategory}
                        disabled={!modalData.showAddRow}
                        data={data}
                    />
                </Grid>
                <Grid item xs={4}>
                    <ConfigRenderInputs
                        fieldType={"type"}
                        editProps={{
                            value: inputs.type || modalData.data['type'],
                            onChange: (val) => {
                                setInputs(inputs => ({
                                    ...inputs,
                                    type: val
                                }));
                            },
                            rowData: {
                                category: inputs.category || modalData.data['category']
                            },
                            type: 'modal',
                        }}
                        disabled={!modalData.showAddRow}
                        data={data}
                    />
                </Grid>
            </Grid>
            <Divider style={{ marginBottom: '10px'}}/>
        </>
    );
};

export default ConfigFields;
